import React from "react";
import RandomPackages from "./RandomPackages";
import "../../styles/home-page-layout.scss";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error("RandomPackagesWrapper: Error caught:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="random-packages random-packages--state">
          <div className="home-state-block home-state-block--warning" role="alert">
            <p className="random-packages-state-text">שגיאה בטעינת חבילות מומלצות</p>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

const RandomPackagesWrapper = () => {
  return (
    <ErrorBoundary>
      <RandomPackages />
    </ErrorBoundary>
  );
};

export default RandomPackagesWrapper;

